import { toast } from "sonner";

export async function copyText(text, msg = "Copied") {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      toast.success(msg);
      return;
    }
    throw new Error("clipboard-unavailable");
  } catch {
    try {
      const t = document.createElement("textarea");
      t.value = text;
      t.style.position = "fixed";
      t.style.opacity = "0";
      document.body.appendChild(t);
      t.focus();
      t.select();
      document.execCommand("copy");
      t.remove();
      toast.success(msg);
    } catch {
      toast.error("Copy failed — please select and copy manually");
    }
  }
}
